<template>
  <div>
    <b-card class="standardpage">
      <b-card-header class="px-2 m-0">
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="documents.icon" class="mr-1"></i>
            <span>{{ documents.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-nav class="ml-3 mt-1" small pills>
          <b-nav-item class="nav-pills-hover-effect mr-1 border-secondary uppercase strong" small
            v-for="item in folder_options" :key="item.label" @click="folder = item.label ? item.label : null"
            :active="folder == item.label ? true : false"> <i :class="folder_icon(item.label)"
              class="fa-1-5x text-warning mr-1"></i>
            {{ item.label ? item.label : 'all' }}</b-nav-item>
        </b-nav>

        <b-card class="w-100pct text-left">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6">
                <b-form-group label-cols="12" label="Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="name" :debounce="documents.debounce" placeholder="Name"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" squared variant="outline-secondary" :disabled="!name" @click="name = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." v-model="eventcode" :clearable="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                    :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested :disabled="readonly">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="category"
                      :debounce="documents.debounce"
                      placeholder="Category"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!category"
                        @click="category = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <treeselect placeholder="Select type..." v-model="category" :clearable="true" :multiple="true"
                    :options="options_categories" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col> -->

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <treeselect placeholder="Select folder..." v-model="category" :multiple="true" :clearable="true"
                    :options="folder_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Modified Date" label-size="sm">
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="date" v-model="date" :opens="'right'" :locale-data="locale_data"
                      :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
                        date = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label="Archive?" label-for="archive" label-cols="12">
                      <treeselect instanceId="archive" type="number" v-model="isarchive" :clearable="true"
                        :options="options_archive"></treeselect>
                    </b-form-group></b-col>
                  <b-col>
                    <b-form-group label="New?" label-for="isnew" label-cols="12">
                      <treeselect instanceId="isnew" type="number" v-model="isnew" :clearable="true"
                        :options="options_isnew"></treeselect>
                    </b-form-group></b-col>
                </b-row>
              </b-col>
              <b-col cols="12" sm="6">
                <b-form-group label-cols="12" label="To" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="to" :debounce="documents.debounce" placeholder="To"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" squared variant="outline-secondary" :disabled="!to" @click="to = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>


            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="documents" :selectall="documents.selectall"
            :icon="documents.icon" :toolbarlibrary="documents.toolbarlibrary" :tools="documents.tools"
            :badges="documents.badges" :fields="documents.fields" :items="documents.items"
            :downloaded="documents.downloaded" :limit="documents.limit" :page="documents.page" :showpages="true"
            :busy="documents.busy" @load="documents_load" @click="documents_click" @select="documents_select">
          </d-table>
          <!-- @select="documents_select" -->
        </div>
      </div>
      <div v-if="component">
        <component :is="component" :selection="documents.selected" :config="cconfig"
          @discard="documents_click('discard')" @refresh="documents_click('go')"></component>
      </div>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import DocumentEdit from "./Components/DocumentEdit";

export default {
  name: "Documents",
  components: { DocumentEdit },
  watch: {
    async date() {
      await this.documents_load(0);
    },
    async name() {
      await this.documents_load(0);
    },
    async folder() {
      await this.documents_load(0);
    },
    async to() {
      await this.documents_load(0);
    },
    async slac() {
      await this.documents_load(0);
    },
    async eventcode() {
      await this.documents_load(0);
    },
    async isarchive() {
      await this.documents_load(0);
    },
    async isnew() {
      await this.documents_load(0);
    },
  },

  data() {
    return {
      folder: null,
      date: {
        startDate: this.$moment().startOf("year").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      name: null,
      to: null,
      slac: [],
      eventcode: null,
      isarchive: "false",
      isnew: null,
      options_categories: [],
      folder_options: [],
      options_archive: [
        {
          id: "true",
          label: "Yes",
        },
        {
          id: "false",
          label: "No",
        },
      ],
      options_isnew: [
        {
          id: "true",
          label: "Yes",
        },
        {
          id: "false",
          label: "No",
        },
      ],
      documents: {
        title: "Documents",
        icon: "fa fa-file text-primary pl-2",
        selectall: false,
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa fa-floppy-o text-primary",
            position: "toolbar,actions",
            action: "saveas",
            label: "Save As",
            component: {
              name: "",
            },
          },
        ],
        tools: "go,filter,download,clipboard,add,edit,archive,unarchive,deleteconfirm,saveas",       
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },

          {
            key: "name",
            label: "Name",
            sortable: true,
            class: "text-left w-20pct",
          },
          {
            key: "size",
            label: "Size",
            sortable: true,
            class: "text-right w-80px d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$options.filters.formatSize(value);
              }
              return result;
            },
          },

          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "text-center",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center",
          },
          // {
          //   key: "to",
          //   label: "To",
          //   sortable: true,
          //   class: "text-center",
          // },
          {
            key: "folder",
            label: "Folder",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                return value.toUpperCase()
              }
            }
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY HH:mm:SS");
              }
              return result;
            },
          },
          // {
          //   key: "type",
          //   label: "Type",
          //   sortable: true,
          //   class: "text-center",
          // },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-80px text-right",
          },
        ],

        badges: [
          {
            key: "type",
            type: "badge",
            other: "dark",
            "File folder": "warning",
            File: "info",
            formatter: (value, key, item) => {
              switch (parseInt(value)) {
                case 0:
                  return "File";
                  break;
                case 1:
                  return "File folder";
                  break;
              }
            },
          },
          {
            key: "folder",
            type: "pill",
            class: "warning",
          },
        ],

        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  computed: {
    readonly() {
      return this.user.rolename == "client";
    },
  },
  async mounted() {
    await this.documents_folders();
    this.folder = this.folder_options[0].id
    await this.documents_load();
  },

  methods: {
    folder_icon(name) {
      if (!name && !this.folder) {
        return 'fa fa-folder-open'
      }
      if (this.folder == name) {
        return 'fa fa-folder-open'
      }
      return 'fa fa-folder'
    },
    async documents_folders() {

      let list = this.user.permissions.split(",").filter(o => o.includes('documents.['))
      for (var k = 0; k < list.length; ++k) {
        list[k] = list[k].split('\"').join('').split('documents.[').join('').split(']').join('')
      }
      // // list.unshift("*")

      let variables = {
        date: [this.date.startDate, this.date.endDate],
      }
      try {
        const response = await this.$apollo.query({
          query: gql`
            query documents_folders ( $date: [String] ) {
              documents_folders (date: $date) {
                  id
                  label
                }
              } 
          `,
          variables,
        })

        let folders = response.data.documents_folders
        this.folder_options = []
        if (list.includes('*')) {
          this.folder_options = folders
        } else {
          for (var k = 0; k < list.length; ++k) {
            let find = folders.find(o => o.id == list[k])
            if (find) {
              this.folder_options.push(find)
            }
          }
        }


      } catch (error) {
        console.log(error);
      }

      if (this.folder_options.length > 0) {
        if (this.folder_options[0].id != null && list.includes('*')) {
          this.folder_options.unshift({ "id": null, "label": null, "__typename": "Documents_folders_output" })
        }
      }
    },
    async documents_load(offset, limit, page) {

      if (this.folder_options.length == 0) { return }

      let state = this.documents;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        date: [this.date.startDate, this.date.endDate],
        name: this.name,
        to: this.to,
        category: this.folder,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        eventcode: this.eventcode,
        isarchive: this.isarchive,
        isnew: this.isnew,
        dateformat: "DD/MM/YYYY HH:MM:SS",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query documents(
              $limit: Int
              $offset: Int
              $dateformat: String
              $name: String
              $to: String
              $category: String
              $date: [String]
              $slac: String
              $eventcode: String
              $isarchive: String
              $isnew: String
            ) {
              documents(
                limit: $limit
                offset: $offset
                name: $name
                to: $to
                category: $category
                date: $date
                slac: $slac
                eventcode: $eventcode
                isarchive: $isarchive
                isnew: $isnew
                dateformat: $dateformat
              ) {
                id
                name
                type
                size
                to
                folder: category
                archive
                new
                attachment
                created_at
                eventcode
                slac
                notes
                updated_by
                updated_at
                created_at
                created_by
                rows
              }
            }
          `,
          variables,
        });

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.documents
        } else {
          state.items = response.data.documents;
        }

        // if (limit == 0) {
        //   state.selected = response.data.documents;
        // } else {
        //   state.items = []
        //   state.items = response.data.documents;
        // }

      } catch (error) {
        console.log(error);
      }
      this.$store.dispatch("documents");
      state.busy = false;
      await this.documents_folders()
    },
    async documents_click(a, ss) {

      let state = this.documents;

      switch (a) {
        case "selectall":
          await this.documents_load(0, 0);
          break;
        case "download_view":
          state.downloaded = []
          state.downloaded = this.state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.documents_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          this.documents_load();
          break;
        case "add":
        case "edit":
          this.component = "DocumentEdit";
          break;
        case "notes":
          this.component = "DocumentNotes";
          break;
        case "delete":
          this.deleteit(ss);
          break;
        // case "download":
        //   await this.download(ss);
        //   break;
        case "archive":
          await this.archive(1)
          break;
        case "unarchive":
          await this.archive(0)
          break;
        case "saveas":
          await this.documents_saveas(ss);
          break;

      }
    },

    async documents_select(ss, tools) {

      let state = this.documents;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "saveas", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "archive", "unarchive"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
    async documents_saveas(ss) {
      this.busy = true;
      let variables = {
        id: ss[0].id,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query documents($id: String) {
              documents(id: $id) {
                id
                data
              }
            }
          `,
          variables,
        });
        if (response.data.documents.length > 0) {
          if (response.data.documents[0].data) {
            this.fileUpload = JSON.parse(response.data.documents[0].data);
            await this.fileUpload_view();
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async deleteit(ss) {
      console.log("deleteit", ss);

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation documents_delete($rows: [Document_input]) {
              documents_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.documents_load(0);
    },

    async archive(a) {
      console.log("archive", a);

      let rows = [];
      this.documents.selected.forEach(function (v) {
        rows.push({ id: v.id, archive: a == 1 ? true : false });
      });

      let variables = {
        rows,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
                mutation documents_save(
                  $rows: [Document_input]
                  $dateformat: String
                ) {
                  documents_save(rows: $rows, dateformat: $dateformat) {
                    id
                  }
                }
              `,
          variables,
        });
        await this.documents_load(0)

      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
    },
  },

};
</script>

<style></style>